import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface OfflineRecordingCapDialogProps {
  open: boolean;
  /** Carry on for another three hours. */
  onContinue: () => void;
  /** Close the recording now and let Wundo write from it. */
  onStop: () => void;
}

/**
 * Three hours in: is anybody still there?
 *
 * The cap exists for the recording nobody closed — a laptop left open after the
 * conversation ended, quietly filling storage with an empty room. So the
 * question defaults to stopping: saying nothing closes it shortly after, and
 * only an answer keeps it running.
 *
 * Dismissing it counts as an answer. Someone who pressed escape is at the
 * keyboard, which is the very thing the cap was checking for.
 */
export function OfflineRecordingCapDialog({
  open,
  onContinue,
  onStop,
}: OfflineRecordingCapDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onContinue()}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>{m.meeting_offline_cap_title()}</DialogTitle>
        </DialogHeader>

        <div className='px-5 py-4'>
          <p className='text-sm text-ink-body'>{m.meeting_offline_cap_body()}</p>
        </div>

        <DialogFooter>
          <Button size='sm' variant='quiet' onClick={onStop}>
            {m.meeting_offline_stop()}
          </Button>
          <Button size='sm' onClick={onContinue}>
            {m.meeting_offline_cap_continue()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
